// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const munkidori: PokeData = {
  "id": 1015,
  "name": "munkidori",
  "height": 10,
  "weight": 122,
  "base_experience": 278,
  "types": [
    PokeType.POISON,
    PokeType.PSYCHIC
  ],
  "api_moves": [
    "scratch",
    "psybeam",
    "confusion",
    "psychic",
    "future-sight",
    "fake-out",
    "flatter",
    "helping-hand",
    "poison-jab",
    "nasty-plot",
    "sludge-wave",
    "clear-smog",
    "parting-shot"
  ],
  "moves": [
    "scratch",
    "psychic",
    "future-sight",
    "flatter",
    "poison-jab",
    "poison-gas",
    "psychic-terrain",
    "psychic-fangs",
    "synchronize",
    "mortal-gas",
    "purify",
    "poison-powder",
    "psy-pulse"
  ],
  "evolution_chain": {
    "id": 541,
    "item": null,
    "species": [
      {
        "name": "munkidori",
        "order": 1017,
        "types": [
          PokeType.POISON,
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 104,
    "speed": 133,
    "ability_power": 163
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": true,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
